module.exports = __webpack_public_path__ + "img/timeframe_availability.f0da38ff.png";